import { useContext, useMemo } from "react";
import AuthContext from "../context/AuthProvider";

const getTenantIdFromSearch = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get("tenant_id") || params.get("tenantId");
};

const getTenantLogoFromSearch = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get("tenant_logo") || params.get("tenantLogo");
};

const getTenantNameFromSearch = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get("tenant_name") || params.get("tenantName");
};

const useTenantBranding = () => {
  const { currentTenant, userTenants, tenantSessions } = useContext(AuthContext);

  return useMemo(() => {
    const tenantIdFromSearch = getTenantIdFromSearch();
    const tenantId =
      currentTenant?.id ||
      tenantIdFromSearch ||
      tenantSessions?.[tenantSessions.length - 1]?.tenant_id ||
      null;

    const matchedUserTenant = (userTenants || []).find(
      (item) => String(item?.tenant?.id || item?.id) === String(tenantId),
    );
    const matchedSession = (tenantSessions || []).find(
      (session) => String(session?.tenant_id) === String(tenantId),
    );

    const tenantLogo =
      currentTenant?.logo ||
      matchedSession?.tenant_logo ||
      matchedSession?.tenant?.logo ||
      matchedUserTenant?.tenant?.logo ||
      matchedUserTenant?.logo ||
      getTenantLogoFromSearch() ||
      null;

    const tenantName =
      currentTenant?.name ||
      matchedSession?.tenant_name ||
      matchedSession?.tenant?.name ||
      matchedUserTenant?.tenant?.name ||
      matchedUserTenant?.name ||
      getTenantNameFromSearch() ||
      null;

    const isTenantContext = Boolean(tenantId);

    return {
      isTenantContext,
      tenantLogo,
      tenantName,
      hideDefaultBranding: isTenantContext,
    };
  }, [currentTenant, tenantSessions, userTenants]);
};

export default useTenantBranding;
